export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL
export enum PLATFORM {
    LAB_OPERATOR = 'laboperator',
    ESSENTIM = 'essentim'
}